import { render, staticRenderFns } from "./MenuReportPayment.vue?vue&type=template&id=12dd0868&scoped=true&"
import script from "./MenuReportPayment.vue?vue&type=script&lang=js&"
export * from "./MenuReportPayment.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportPayment.vue?vue&type=style&index=0&id=12dd0868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd0868",
  null
  
)

export default component.exports